import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { fetchAssinaturaAcordo } from '../store/actions';
import { useAppDispatch } from '@/store/hooks';
const INTERVALO_MINIMO_REVALIDACAO_MS = 10_000;
export function useAssinaturaAcordoPainel(casoId, ativo) {
  const $ = _c(8);
  const dispatch = useAppDispatch();
  const ultimaBuscaEmRef = useRef(0);
  let t0;
  if ($[0] !== casoId || $[1] !== dispatch) {
    t0 = () => {
      if (!casoId) {
        return;
      }
      ultimaBuscaEmRef.current = Date.now();
      dispatch(fetchAssinaturaAcordo(casoId));
    };
    $[0] = casoId;
    $[1] = dispatch;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const buscarPainel = t0;
  let t1;
  let t2;
  if ($[3] !== ativo || $[4] !== buscarPainel || $[5] !== casoId) {
    t1 = () => {
      if (!ativo || !casoId) {
        return;
      }
      buscarPainel();
      const revalidar = () => {
        if (document.visibilityState === "hidden") {
          return;
        }
        if (Date.now() - ultimaBuscaEmRef.current < INTERVALO_MINIMO_REVALIDACAO_MS) {
          return;
        }
        buscarPainel();
      };
      window.addEventListener("focus", revalidar);
      document.addEventListener("visibilitychange", revalidar);
      return () => {
        window.removeEventListener("focus", revalidar);
        document.removeEventListener("visibilitychange", revalidar);
      };
    };
    t2 = [ativo, casoId, buscarPainel];
    $[3] = ativo;
    $[4] = buscarPainel;
    $[5] = casoId;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
}